import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMonitors = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.25 18.75H16.75C17.4404 18.75 18 18.1904 18 17.5V8.75C18 8.05964 17.4404 7.5 16.75 7.5L4.25 7.5C3.55964 7.5 3 8.05964 3 8.75L3 17.5C3 18.1904 3.55964 18.75 4.25 18.75Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 15.75H19.75C20.4404 15.75 21 15.1904 21 14.5V5.75C21 5.05964 20.4404 4.5 19.75 4.5L7.25 4.5C6.55965 4.5 6 5.05964 6 5.75V7.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.75 21H8.25",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgMonitors);
export { ForwardRef as ReactComponent };
